import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import '../../style/HelpCenter.scss';
import { t } from '../../i18n';

const TOURS = {
  list: [
    { selector: '.tsk-palette-trigger', title: t('ui.tour.l1.t'), text: t('ui.tour.l1.x') },
    { selector: '.tsk-topbar-primary', title: t('ui.tour.l2.t'), text: t('ui.tour.l2.x') },
    { selector: '.tsk-stats', title: t('ui.tour.l3.t'), text: t('ui.tour.l3.x') },
    { selector: '.tsk-project-card', title: t('ui.tour.l4.t'), text: t('ui.tour.l4.x') },
  ],
  editor: [
    { selector: '.tsk-editor-rail', title: t('ui.tour.e1.t'), text: t('ui.tour.e1.x') },
    { selector: '.tsk-editor-center', title: t('ui.tour.e2.t'), text: t('ui.tour.e2.x') },
    { selector: '.tsk-editor-props', title: t('ui.tour.e3.t'), text: t('ui.tour.e3.x') },
    { selector: '.tsk-topbar-primary', title: t('ui.tour.e4.t'), text: t('ui.tour.e4.x') },
  ],
};

const doneKey = (name) => `tsk-tour-done-${name}`;
const isDone = (name) => { try { return window.localStorage.getItem(doneKey(name)) === '1'; } catch (e) { return true; } };
const markDone = (name) => { try { window.localStorage.setItem(doneKey(name), '1'); } catch (e) { /* ignore */ } };

const tourNameForPath = (path) => {
  if (path === '/project') return 'list';
  if (/^\/project\/[^/]+\/page\//.test(path)) return 'editor';
  return null;
};

// Visite guidée : met en surbrillance quelques éléments clés, une seule fois par parcours (relançable depuis l'aide).
class Tour extends Component {

  state = { name: null, index: 0, rect: null };

  componentDidMount() {
    window.addEventListener('tsk-start-tour', this.onManualStart);
    window.addEventListener('resize', this.measure);
    this.timer = setInterval(this.measure, 400);
    this.scheduleAuto();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (this.state.name) this.setState({ name: null });
      this.scheduleAuto();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('tsk-start-tour', this.onManualStart);
    window.removeEventListener('resize', this.measure);
    clearInterval(this.timer);
    clearTimeout(this.autoTimer);
  }

  scheduleAuto() {
    clearTimeout(this.autoTimer);
    const name = tourNameForPath(this.props.location.pathname);
    if (!name || isDone(name)) return;
    this.autoTimer = setTimeout(() => this.start(name), 1800);
  }

  onManualStart = () => {
    const name = tourNameForPath(this.props.location.pathname);
    if (name) this.start(name);
    else this.props.history.push('/project');
  };

  start(name) {
    if (!TOURS[name].some((s) => document.querySelector(s.selector))) return;
    this.setState({ name, index: 0 }, this.measure);
  }

  steps() {
    const { name } = this.state;
    return name ? TOURS[name].filter((s) => document.querySelector(s.selector)) : [];
  }

  measure = () => {
    const step = this.steps()[this.state.index];
    if (!step) { if (this.state.rect) this.setState({ rect: null }); return; }
    const el = document.querySelector(step.selector);
    const r = el.getBoundingClientRect();
    const rect = { top: r.top, left: r.left, width: r.width, height: r.height };
    const prev = this.state.rect;
    if (!prev || prev.top !== rect.top || prev.left !== rect.left || prev.width !== rect.width || prev.height !== rect.height) this.setState({ rect });
  };

  finish = () => {
    markDone(this.state.name);
    this.setState({ name: null, index: 0, rect: null });
  };

  go = (delta) => {
    const steps = this.steps();
    const next = this.state.index + delta;
    if (next >= steps.length) this.finish();
    else this.setState({ index: Math.max(0, next) }, this.measure);
  };

  render() {
    const steps = this.steps();
    const step = steps[this.state.index];
    const { rect } = this.state;
    if (!step || !rect) return null;
    const pad = 6;
    const popW = 320;
    const below = rect.top + rect.height + 16 + 190 < window.innerHeight;
    const popTop = below ? rect.top + rect.height + 14 : Math.max(12, rect.top - 190);
    const popLeft = Math.min(Math.max(12, rect.left), window.innerWidth - popW - 12);
    return (
      <div className='tsk-tour' role='dialog' aria-label={t('ui.tour.aria')}>
        <div className='tsk-tour__backdrop' onClick={this.finish} />
        <div
          className='tsk-tour__spot'
          style={{ top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2 }}
        />
        <div className='tsk-tour__pop' style={{ top: popTop, left: popLeft, width: popW }}>
          <span className='tsk-tour__count'>{this.state.index + 1} / {steps.length}</span>
          <h4>{step.title}</h4>
          <p>{step.text}</p>
          <div className='tsk-tour__actions'>
            <button type='button' className='tsk-tour__skip' onClick={this.finish}>{t('ui.tour.skip')}</button>
            <span />
            {this.state.index > 0 && <button type='button' className='tsk-tour__btn' onClick={() => this.go(-1)}>{t('ui.tour.prev')}</button>}
            <button type='button' className='tsk-tour__btn tsk-tour__btn--primary' onClick={() => this.go(1)}>
              {this.state.index === steps.length - 1 ? t('ui.tour.done') : t('ui.tour.next')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Tour);
